
import moment from 'moment'
/**
 * 常用函数集
 * 陈海晶
 *2022/07/04
 */

/**
 * @description判断对象为空
 *
 * @param {Function} obj  是否为空的对象
 * @return  Boolen 判断结果
 */
function isEmptyObject(obj) {
 
  return Object.keys(obj).length == 0
}


/**
 * @description 是否为数据
 * @param {value} value 判断的值
 * @returns {*} 是否为数组
 */
function issarray(value) {
  if (typeof Array.isArray === 'function') {
    return Array.isArray(value)
  }
  return Object.prototype.toString.call(value) === '[object Array]'
}

/**
 * @description 深度克隆
 * @param {object} obj 需要深度克隆的对象
 * @returns {*} 克隆后的对象或者原值（不是对象）
 */
function deepClone(obj) {

  // 对常见的“非”值，直接返回原来值
  if ([null, undefined, NaN, false].includes(obj)) return obj
  if (typeof obj !== 'object' && typeof obj !== 'function') {
    // 原始类型直接返回
    return obj
  }

  // if (obj instanceof Date) {
  //   return new Date(obj); // 处理日期对象
  // }

  const o = issarray(obj) ? [] : {}

  for (const i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (obj[i] instanceof Date) {
        o[i] = obj[i]
      } else {
        o[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i]
      }

    }
  }
  return o
}



/**
 * @param {number[]} nums
 * @param {number} target
 * @return {number}
 */
let search = function (nums, target) {
  var left = 0, right = nums.length - 1
  while (left <= right) {
    var mid = (left + right) >> 1;
    if (nums[mid] > target) {
      right = mid - 1
    }
    if (nums[mid] === target) return mid;
    if (nums[mid] < target) {
      left = mid + 1
    }
  }
  return -1
};

/**
 * @description 进行延时，以达到可以简写代码的目的 比如: await uni.$u.sleep(20)将会阻塞20ms
 * @param {number} value 堵塞时间 单位ms 毫秒
 * @returns {Promise} 返回promise
 */
let sleep = (value = 30) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, value)
  })
}

let arrChunk = (arr, size) => { //数组切片
  if (!arr || arr.length === 0) {
    return [];
  }
  const tempArr = [];
  const chunkLen = Math.ceil(arr.length / size);
  let last = 0;
  for (let i = 0; i < chunkLen; i++) {
    if (size * i >= arr.length) {
      last = arr.length;
    } else {
      last = size * i + size;
    }
    tempArr.push(arr.slice(size * i, last));
  }
  return tempArr;
}

/**
 * @description 字母排序数组
 * @param {object} obj 需要分类的数组
 * @returns {*} 完成分类的数组
 */

const pinyin = require("./js-pinyin");
let ySegSort = (arr) => {

  function getFirstChar(str) {
    let strarr = str.split("")

    if (strarr.length > 2 && strarr[0] == "重" && strarr[1] == "庆") {
      return "c"
    }
    // 获取字符串的首个字符
    const firstChar = str.charAt(0);

    // 判断字符是否为汉字
    if (/^[\u4e00-\u9fa5]$/.test(firstChar)) {
      // 如果是汉字，则返回其拼音的首字母
      return pinyin.getCamelChars(firstChar);
    } else {
      // 否则直接返回字符本身
      return firstChar;
    }
  }

  const result = {};

  for (let i = 0; i < arr.length; i++) {

    const firstChar = getFirstChar(arr[i]);

 
    if (/\d/.test(firstChar)) {

      if (!result["*"]) {
        result["*"] = { letter: "*", data: [] };
      }
      result["*"].data.push(arr[i]);
    } else if (/^[a-zA-Z]$/.test(firstChar)) {
      // 判断是否为英文字符

      const letter = firstChar.toUpperCase();

      // 如果该字母分类不存在，则创建一个新数组
      if (!result[letter]) {
        result[letter] = { letter: letter, data: [] };
      }
      result[letter].data.push(arr[i]);
    } else { // 如果是汉字，则将其转换为拼音，并获取拼音的首字母


      const py = pinyin(arr[i], { style: pinyin.STYLE_FIRST_LETTER });

      const pyFirstChar = py[0][0].toUpperCase();


      // 如果该字母分类不存在，则创建一个新数组
      if (!result[pyFirstChar]) {
        result[pyFirstChar] = { letter: pyFirstChar, data: [] };
      }
      result[pyFirstChar].data.push(arr[i]);
    }
  }

  // 按照英文字母顺序对分类结果进行排序
  const sortedResult = {};
  Object.keys(result)
    .sort()
    .forEach(function (key) {
      sortedResult[key] = result[key];
    });

 
  if (sortedResult["*"]) {
    const keys = Object.keys(sortedResult);

    if (keys.length >= 1) {
      const firstKey = keys.shift(); // 获取第一个键
      const firstValue = sortedResult[firstKey]; // 获取第一个值
      delete sortedResult[firstKey]; // 删除第一个键值对
      sortedResult[firstKey] = firstValue; // 添加第一个键值对到末尾
    }
  }


  return Object.values(sortedResult)

}



let checkvalue = (value) => { //判断是数字0 还是false
  if (value === 0) {
    return true
  } else if (value === false || value === null || value === undefined) {
    return false
  }
}


function parseQueryParams(queryParams) { //解析url
  var currentUrl = window.location.href;
  var domain = window.location.hostname;
  var path = window.location.pathname;
  var queryParams = window.location.search;
  var params = {};
  if (queryParams.length > 0) {
    var pairs = queryParams.substr(1).split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
  }

  return {
    params,
    currentUrl,
    domain,
    path
  };
}




const areObjectsEqual = (obj1, obj2) => { //判断俩个对象是否为浅相等
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (!obj2.hasOwnProperty(key) || obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
}

const tmierIntalze=(data,timeType)=>{
  
  if (timeType == "5m" || timeType == "1h") {
    return moment(data).format('M-D H:mm')
   
  } else if (timeType == "1d") {
    return moment(data).format('YYYY-M-D')
    
  } else if (timeType == "1M") {
    return moment(data).format('YYYY-M')
  
  }
}



export default {
  isEmptyObject,
  deepClone,
  issarray,
  search,
  sleep,
  arrChunk,
  ySegSort,
  checkvalue,
  parseQueryParams,
  areObjectsEqual,
  tmierIntalze
}
